import { Controller } from "@hotwired/stimulus";
import compactNumber from "../lib/compact_number";

export default class extends Controller {
  connect() {
    this.element.querySelectorAll("[data-compact-number-value]").forEach((element) => {
      element.textContent = compactNumber(element.dataset.compactNumberValue);
    });
  }
}
